import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M2.5 11.6667V8.33341C2.5 5.19072 2.5 3.61937 3.47631 2.64306C4.45262 1.66675 6.02397 1.66675 9.16667 1.66675H10.8333C13.976 1.66675 15.5474 1.66675 16.5237 2.64306C17.068 3.18738 17.3089 3.91665 17.4154 5.00008M17.5 8.33341V11.6667C17.5 14.8094 17.5 16.3808 16.5237 17.3571C15.5474 18.3334 13.976 18.3334 10.8333 18.3334H9.16667C6.02397 18.3334 4.45262 18.3334 3.47631 17.3571C2.93199 16.8128 2.69114 16.0835 2.58458 15.0001",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M5.83301 8.20521H11.544C12.9923 8.20521 14.1663 9.3532 14.1663 10.7693C14.1663 12.1854 12.9923 13.3334 11.544 13.3334H8.10574M5.83301 8.20521L7.53755 6.66675M5.83301 8.20521L7.53755 9.74367",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }